import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobalsLocal
import com.varabyte.kobweb.navigation.RoutePrefix
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.silk.defer.renderWithDeferred
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main(): Unit {
    RoutePrefix.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { ir.yusefpasha.pages.HomePage() }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.initSilkHook = { ctx ->
        ctx.theme.registerComponentStyle(ir.yusefpasha.style.AboutImageStyle)
        ctx.theme.registerComponentStyle(ir.yusefpasha.style.AboutTextStyle)
        ctx.theme.registerComponentStyle(ir.yusefpasha.style.BackToTopStyle)
        ctx.theme.registerComponentStyle(ir.yusefpasha.style.InputStyle)
        ctx.theme.registerComponentStyle(ir.yusefpasha.style.NavigationItemStyle)
        ctx.theme.registerComponentStyle(ir.yusefpasha.style.LogoStyle)
        ctx.theme.registerComponentStyle(ir.yusefpasha.style.SocialLinkStyle)
        ctx.theme.registerComponentStyle(ir.yusefpasha.style.MainButtonStyle)
        ctx.theme.registerComponentStyle(ir.yusefpasha.style.MainImageStyle)
        ctx.theme.registerComponentStyle(ir.yusefpasha.style.PortfolioSectionStyle)
        ctx.theme.registerComponentStyle(ir.yusefpasha.style.PortfolioArrowIconStyle)
        ctx.theme.registerComponentStyle(ir.yusefpasha.style.ServiceCardStyle)
        ir.yusefpasha.updateTheme(ctx)
    }

    router.navigateTo(window.location.href.removePrefix(window.location.origin))

    // For SEO, we may bake the contents of a page in at build time. However, we will overwrite them
    // the first time we render this page with their composable, dynamic versions. Think of this as
    // poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("root")!!
    while (root.firstChild != null) {
        root.removeChild(root.firstChild!!)
    }

    renderComposable(rootElementId = "root") {
        CompositionLocalProvider(
            AppGlobalsLocal provides mapOf("title" to "Yusef Pasha")
        ) { ir.yusefpasha.MyApp {
              router.renderActivePage { renderWithDeferred { it() } }
        } }
    }
}
